import React, { Component } from 'react';
import {Link, Route, Switch, Redirect} from 'react-router-dom';
import CheckUnblock from './CheckUnblock/CheckUnblock';
import VerifyOtpCode from './VerifyOtpCode/VerifyOtpCode';
import SuccessChange from './SuccessChange/SuccessChange';

export default class UnblockUser extends Component {
    render() {
        let {isAuthed, updateAppState} = this.props;
        if (isAuthed) {
            return <Redirect to="/dashboard/"/>
        }
        return (   
            <Switch>
                <Route exact path="/login/individual/mobile/unblock-user/1" render={(routeProps) => <CheckUnblock {...routeProps} updateAppState={updateAppState}/>}/>
                <Route exact path="/login/individual/mobile/unblock-user/2" render={(routeProps) => <VerifyOtpCode {...routeProps} updateAppState={updateAppState}/>}/>
                <Route exact path="/login/individual/mobile/unblock-user/3" render={(routeProps) => <SuccessChange {...routeProps} updateAppState={updateAppState}/>}/>
                <Redirect exact from="/login/individual/mobile/unblock-user" to="/login/individual/mobile/unblock-user/1"/>
                <Route exact path="/login/juridical/mobile/unblock-user/1" render={(routeProps) => <CheckUnblock {...routeProps} updateAppState={updateAppState}/>}/>
                <Route exact path="/login/juridical/mobile/unblock-user/2" render={(routeProps) => <VerifyOtpCode {...routeProps} updateAppState={updateAppState}/>}/>
                <Route exact path="/login/juridical/mobile/unblock-user/3" render={(routeProps) => <SuccessChange {...routeProps} updateAppState={updateAppState}/>}/>
                <Redirect exact from="/login/juridical/mobile/unblock-user" to="/login/juridical/mobile/unblock-user/1"/>
            </Switch>
        )
    }
}
